import React from 'react';
import './Hero.css';

const Hero = () => {
    return (
        <section className="hero">
            <div className="hero-body">
                <div className="container">
                    <div className="columns">
                        <div className="column is-offset-1-tablet is-10-tablet is-11-desktop is-three-fifths-widescreen">
                            <div className="title-wrapper animated fadeInLeft">
                                <h1 className="hidden">Terms and Conditions</h1>
                                <div className="pre-title">HUDSON PACIFIC PROPERTIES</div>
                                <div className="big-title">TERMS AND CONDITIONS</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default Hero;
